import { Box, Theme, Typography } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router-dom';

export default function GoalCalculatorCard({ data }: { data: any }): JSX.Element {
    const history = useHistory();
    const { pathname } = history.location
    const goToGoalCalculator = () => {
        history.push(`${pathname}/goal-calculator`)
    }
    return (
        <Box sx={(theme: Theme) => ({
            border: `1px solid ${theme.palette.text.secondary}B2`,
            borderRadius: '10px',
            padding: '20px',
            minWidth: '250px',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.primary[100],
                border: `2px solid ${theme.palette.primary[100]}`,
            },
            '&:focus-visible': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: '2px',
                backgroundColor: theme.palette.primary[100],
            }
        })}
            role="button"
            tabIndex={0}
            onClick={goToGoalCalculator}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    goToGoalCalculator();
                }
            }}
        >
            {data?.icon}
            <Typography variant='body_500' color='text.secondary' mt={1}>
                {data?.label}
            </Typography>
        </Box>
    )
}
